/**
 * Generic page-shaped skeleton used as the global Suspense fallback.
 * Replaces the legacy spinner so route-level chunk loads have a stable
 * layout placeholder instead of a CLS-inducing centred spinner.
 *
 * Agent B: import this from `@/components/skeletons/PageSkeleton` and pass
 * it as `<Suspense fallback={<PageSkeleton />}>` in App.tsx.
 */
import React from 'react';

const block: React.CSSProperties = {
  borderRadius: 6,
};

export function PageSkeleton() {
  return (
    <div
      style={{ padding: 32, maxWidth: 1200, margin: '0 auto' }}
      role="status"
      aria-label="Loading page"
    >
      <div
        className="skeleton-shimmer"
        style={{ ...block, height: 32, width: '40%', marginBottom: 24 }}
      />
      <div
        className="skeleton-shimmer"
        style={{ ...block, height: 16, width: '70%', marginBottom: 12 }}
      />
      <div
        className="skeleton-shimmer"
        style={{ ...block, height: 16, width: '60%', marginBottom: 12 }}
      />
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
          gap: 16,
          marginTop: 32,
        }}
      >
        {Array.from({ length: 8 }).map((_, i) => (
          <div
            key={i}
            className="skeleton-shimmer"
            style={{ ...block, height: 200, borderRadius: 8 }}
          />
        ))}
      </div>
    </div>
  );
}

export default PageSkeleton;
